export default __webpack_public_path__ + "static/media/canada_cheque.d9106438.png";